"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

/* eslint-disable indent */
function OptionsImage(props) {
  var option = props.option,
      isSubmitted = props.isSubmitted;
  var imageUrl = option.imageUrl;

  if (!imageUrl) {
    return null;
  }

  return _react.default.createElement("div", {
    className: (0, _styles.imageContainer)(isSubmitted ? 36 : 72)
  }, _react.default.createElement("img", {
    src: imageUrl,
    alt: option.text,
    className: _styles.optionImage
  }), ' ');
}

var _default = OptionsImage;
exports.default = _default;